// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"a9136d3c","977":"e8ab04c1"}[chunkId] + ".chunk.js";
};